import type { IUserProfileClaim } from '@gik/calendar/models/Claim';
import bemBlock from '@gik/core/utils/bemBlock';
import React from 'react';
import ClaimedItemsList from './ClaimedItemsList';
import ClaimsListSkeleton from './ClaimsListSkeleton';

export interface IClaimsListProps {
  items?: IUserProfileClaim[];
  loading?: boolean;
  emptyText: string;
  className?: string;
}

const blockName = 'claims-list';

function ClaimsList({ items, loading, emptyText, className }: IClaimsListProps) {
  const bem = bemBlock(blockName);

  if (loading) return <ClaimsListSkeleton />;

  if (items?.length === 0) {
    return (
      <div className={bem(null, 'empty')}>
        <div>
          <span className={bem('empty-text')}>{emptyText}</span>
        </div>
      </div>
    );
  }

  return <ClaimedItemsList className={className} items={items} />;
}

export default ClaimsList;
